import React from 'react'

const TableToolbar = ({
  kicker,
  title,
  subtitle,
  meta,
  actions,
  children,
  className = '',
}) => (
  <div
    className={`flex flex-col gap-4 border-b border-rule p-4 sm:flex-row sm:items-center sm:justify-between ${className}`}
  >
    <div className="min-w-0">
      {kicker && <p className="nx-manifest-kicker">{kicker}</p>}
      {title && (
        <h2 className="mt-1 font-display text-2xl tracking-wide text-paper">{title}</h2>
      )}
      {subtitle && <p className="mt-1 text-xs text-muted">{subtitle}</p>}
      {meta && <div className="mt-1 text-xs text-muted">{meta}</div>}
    </div>
    <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center">
      {children}
      {actions}
    </div>
  </div>
)

export default TableToolbar
